import React from 'react';

function ClassManagement(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g id='school'>
        <mask
          id='mask0_6599_276'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='24'
          height='24'
        >
          <rect id='Bounding box' width='24' height='24' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_6599_276)'>
          <path
            id='Vector'
            d='M6.0502 17.7749C5.71686 17.5916 5.45853 17.3457 5.2752 17.0374C5.09186 16.7291 5.0002 16.3832 5.0002 15.9999V11.1999L2.6002 9.8749C2.41686 9.7749 2.28353 9.6499 2.2002 9.4999C2.11686 9.3499 2.0752 9.18324 2.0752 8.9999C2.0752 8.81657 2.11686 8.6499 2.2002 8.4999C2.28353 8.3499 2.41686 8.2249 2.6002 8.1249L11.0502 3.5249C11.2002 3.44157 11.3544 3.37907 11.5127 3.3374C11.671 3.29574 11.8335 3.2749 12.0002 3.2749C12.1669 3.2749 12.3294 3.29574 12.4877 3.3374C12.646 3.37907 12.8002 3.44157 12.9502 3.5249L22.4752 8.7249C22.6419 8.80824 22.771 8.92907 22.8627 9.0874C22.9544 9.24574 23.0002 9.41657 23.0002 9.5999V15.9999C23.0002 16.2832 22.9044 16.5207 22.7127 16.7124C22.521 16.9041 22.2835 16.9999 22.0002 16.9999C21.7169 16.9999 21.4794 16.9041 21.2877 16.7124C21.096 16.5207 21.0002 16.2832 21.0002 15.9999V10.0999L19.0002 11.1999V15.9999C19.0002 16.3832 18.9085 16.7291 18.7252 17.0374C18.5419 17.3457 18.2835 17.5916 17.9502 17.7749L12.9502 20.4749C12.8002 20.5582 12.646 20.6207 12.4877 20.6624C12.3294 20.7041 12.1669 20.7249 12.0002 20.7249C11.8335 20.7249 11.671 20.7041 11.5127 20.6624C11.3544 20.6207 11.2002 20.5582 11.0502 20.4749L6.0502 17.7749ZM12.0002 12.6999L18.8502 8.9999L12.0002 5.2999L5.1502 8.9999L12.0002 12.6999ZM12.0002 18.7249L17.0002 16.0249V12.2499L12.9752 14.4749C12.8252 14.5582 12.6669 14.6207 12.5002 14.6624C12.3335 14.7041 12.1669 14.7249 12.0002 14.7249C11.8335 14.7249 11.6669 14.7041 11.5002 14.6624C11.3335 14.6207 11.1752 14.5582 11.0252 14.4749L7.0002 12.2499V16.0249L12.0002 18.7249Z'
            fill='#717171'
          />
        </g>
      </g>
    </svg>
  );
}

ClassManagement.displayName = 'ClassManagement';

export default ClassManagement;
